import { Program } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { PopularProgramCardImage } from './Image'
import { PopularProgramCardContent } from './Content'
import { PopularProgramCardBadge } from './Badge'

export const PopularProgramCard = ({
  imagePath,
  objectives,
  tags,
  name,
  capacity,
  requiredTime,
  idx,
  id,
  slug,
}: Program & { idx: number }): JSX.Element => (
  <div className="flex relative flex-col lg:flex-row lg:items-start w-[87.2vw] lg:w-[62.6vw] rounded-b-[20px] shadow-button">
    <PopularProgramCardImage {...{ imagePath, name, id, slug }} />
    <div className="pt-[2.9vw] lg:pt-[3vw] lg:pr-[1.7vw] pb-[5.3vw] lg:pb-[1vw] pl-[6.1vw] lg:pl-[2vw] lg:w-[30vw]">
      <PopularProgramCardContent
        transitionDetailPath={''}
        {...{ objectives, tags, name, capacity, requiredTime, id }}
        ProgramHeadingTag="h2"
      />
    </div>

    <div className="absolute top-[-8vw] lg:top-[-3vw] right-[-7.5vw] lg:right-[-2.5vw]">
      <PopularProgramCardBadge {...{ idx }} />
    </div>
  </div>
)
